import React, { useState } from 'react';
import AddCreativeDialog from './AddCreativeDialog';
import { addCreativesToMeasurement, CreativeWithExternalId } from '../../services/measurementService';
import './MeasurementForm.css';
import '../../pages/CreateMeasurementPage.css';

interface AddCreativesSectionProps {
  measurementId: string;
  onUploaded: () => Promise<void> | void;
}

const AddCreativesSection: React.FC<AddCreativesSectionProps> = ({
  measurementId,
  onUploaded,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleAdd = async (creative: CreativeWithExternalId) => {
    setIsUploading(true);
    setSubmitError('');
    try {
      await addCreativesToMeasurement(measurementId, [creative]);
      await onUploaded();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to add creative';
      setSubmitError(message);
      throw err;
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="add-creatives-section">
      <button
        type="button"
        className="add-creative-open-button"
        onClick={() => {
          setSubmitError('');
          setDialogOpen(true);
        }}
        disabled={isUploading}
      >
        Add creative
      </button>
      {submitError && (
        <div className="error-message">{submitError}</div>
      )}
      <AddCreativeDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onAdd={handleAdd}
        disabled={isUploading}
      />
    </div>
  );
};

export default AddCreativesSection;
